import { render, staticRenderFns } from "./StoreEditDeletePraticaTags.vue?vue&type=template&id=2824b6b8"
import script from "./StoreEditDeletePraticaTags.vue?vue&type=script&lang=js"
export * from "./StoreEditDeletePraticaTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports